module.exports = __webpack_public_path__ + "static/media/search-dollar.a60b4965.svg";